import React from 'react';
import classNames from 'classnames';
import typeUtils from '../../../../../utils/type';
import classes from '../styles/index.module.scss';
import RouteLink from '../../../../../components/RouteLink';

function isExternalUrl(url) {
	// Create an anchor element to use the browser to parse the URL
	const anchor = document.createElement('a');
	anchor.href = url;

	// Compare the anchor's host (domain) with the current location's host
	return anchor.host !== window.location.host;
}

const ValueIndicator = ({ value, title, url, forceUseLink }) => {
	const dataClassNames = classNames(classes.indicator__data, classes.indicator__data_centered);
	const indicatorClassNames = classNames(classes.indicator, classes.indicator_centered);
	const valueClassNames = classNames(classes.indicator__value, classes.indicator__value_bold);
	const hasUrl = !typeUtils.isNullOrUndefined(url);
	const inner = (
		<div className={dataClassNames}>
			<div className={valueClassNames}>{value}</div>
			<div className={classes.indicator__title}>{title}</div>
		</div>
	);

	if (hasUrl) {
		const target = isExternalUrl(url) ? '_blank' : '_self';

		return (
			<RouteLink
				className={indicatorClassNames}
				href={url}
				forceUseLink={forceUseLink}
				target={target}
				useDirty
			>
				{inner}
			</RouteLink>
		);
	}

	return <div className={indicatorClassNames}>{inner}</div>;
};

export { ValueIndicator };
